import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
export default class CookieConsentBanner extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.service = this.attrs.service;
    this.visible = this.service.preference() === null;
    this.openHandler = () => {
      this.visible = true;
      m.redraw();
    };
    window.addEventListener('devconnect:cookie-consent-open', this.openHandler);
  }
  onremove(vnode) {
    window.removeEventListener('devconnect:cookie-consent-open', this.openHandler);
    super.onremove(vnode);
  }
  view() {
    if (!this.visible) return null;
    return m('.dc-cookie-consent', {
      role: 'dialog',
      'aria-labelledby': 'dc-cookie-title',
      'aria-describedby': 'dc-cookie-description'
    }, [m('.dc-cookie-consent__copy', [m('strong#dc-cookie-title', 'Cookies и приватность'), m('p#dc-cookie-description', ['Необходимые cookies обеспечивают вход и безопасность. Яндекс Метрика включится только с вашего разрешения. ', m('a', {
      href: '/cookies'
    }, 'Подробнее')])]), m('.dc-cookie-consent__actions', [m(Button, {
      className: 'Button',
      onclick: () => this.choose('necessary')
    }, 'Только необходимые'), m(Button, {
      className: 'Button Button--primary',
      onclick: () => this.choose('analytics')
    }, 'Разрешить аналитику')])]);
  }
  choose(preference) {
    this.service.save(preference);
    this.visible = false;
    m.redraw();
  }
}
flarum.reg.add('devconnect-legal', 'forum/components/CookieConsentBanner', CookieConsentBanner);